<template>
  <div class="mc-index">
    <h1 class="text-align-center">斑马邦赛事通-测试页面</h1>
    <div class="box-container">
      <van-button block type="primary" @click="goNextPage('login')">跳转登录授权页面</van-button>
      <van-button block type="primary" @click="goNextPage('profile')" style="margin-top: 20px;">个人中心</van-button>
      <van-button block type="primary" @click="go" style="margin-top: 20px;">赛事</van-button>
      <van-button block type="primary" @click="goDetail" style="margin-top: 20px;">邦少年赛事</van-button>
      <div>1</div>
    </div>
  </div>
</template>

<script>
// import variables from '@/assets/css/variables.scss'

export default {
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
    goNextPage(name, params) {
      // debugger
      let path = ''
      if (name === 'login') {
        path = '/auth/login'
      } else if (name === 'profile') {
        path = '/auth/profile'
      }
      this.$router.push({ path, params })
    },
    go() {
      this.$router.push({ path: '/match'})
    },
    goDetail() {
      this.$router.push({ path: '/auth/game-detail?gameId=525197'})
    }
  }
}
</script>

<style lang="scss" scoped>
.mc-index {
  .text-align-center {
    text-align: center;
  }
  .box-container {
    padding: 16px;
  }
}
</style>
